<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-medium"
    title="運用コマンド実行結果表示"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <v-card-text class="modal-body">
        <div class="d-flex justify-end mr-2">
          <v-btn color="primary" @click="download">テキストダウンロード</v-btn>
        </div>
        <pre
          class="ma-4 overflow-auto text-body-2"
          v-for="(command, index) in displayCommandContents"
          :key="index"
          >{{ command }}</pre
        >
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="outlined" color="primary" @click="cancel"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { CommandResult, LineCategory } from "@/apis/NwOperationToolApi";

export default defineComponent({
  name: "OperationCmdReference",
  props: {
    /** 参照回線種別 */
    lineCategory: {
      type: String as PropType<LineCategory>,
      required: true,
    },
    /** X番号/W番号（E番号） */
    number: {
      type: String as PropType<string>,
      required: true,
    },
    /** コマンド登録番号 */
    entryNumbers: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  data() {
    return {
      commands: [] as CommandResult[],
      isLoaded: false,
    };
  },
  computed: {
    /** コマンド名を変換し、実行結果のエスケープ処理を除去した結果の一覧、実施結果がnullのものは返却しない */
    displayCommandContents(): (string | null)[] {
      return this.commands
        .map((e) =>
          e.result
            ? (e.commandInfo.commandType === "PING" ||
              e.commandInfo.commandType === "TRACEROUTE"
                ? this.$filter.enumTo(
                    e.commandInfo.commandType,
                    "commandInfo_commandType_detail"
                  ) +
                  " " +
                  this.$filter.emptyTo(e.commandInfo.ipAddress, "-")
                : this.$filter.enumTo(
                    e.commandInfo.commandType,
                    "commandInfo_commandType_detail"
                  )) +
              "\n" +
              unescape(e.result)
                .replace(/^"/, "")
                .replace(/"$/, "")
                .replace(/\\n/g, "\n")
                .replace(/\\"/g, '"')
            : null
        )
        .filter((e) => e);
    },
  },
  async mounted() {
    for (const entryNumber of this.entryNumbers) {
      this.commands = [
        ...this.commands,
        this.lineCategory === "AC"
          ? await this.$api.nwOperationTool.getCommandResult("AC", entryNumber)
          : await this.$api.nwOperationTool.getCommandResult("VN", entryNumber),
      ];
    }
    this.isLoaded = true;
  },
  methods: {
    /** テキストダウンロード */
    download() {
      let feature = "";
      switch (this.lineCategory) {
        case "AC":
          feature = "IPsec";
          break;
        case "L2L3":
        case "VN":
          feature = this.lineCategory;
          break;
        case "CLOUD":
          feature = "multicloud";
          break;
      }
      this.$service.file.downloadText(
        `${this.number}_${feature}_operation_${this.$moment().format(
          "YYYYMMDDHHmmss"
        )}.log`,
        this.displayCommandContents.map((e) => e).join("\n\n")
      );
    },
  },
});
</script>
